<script setup lang="ts">
import MonospaceLogoDark from '~/assets/img/monospace-logo-color-dark-full.svg';
import MonospaceLogoLight from '~/assets/img/monospace-logo-color-light-full.svg';
</script>

<template>
	<header aria-label="Monospace" class="flex items-center gap-3">
		<MonospaceLogoLight aria-hidden="true" class="hidden h-full w-40 object-contain dark:block" />
		<MonospaceLogoDark aria-hidden="true" class="block h-full w-40 object-contain dark:hidden" />
	</header>
</template>
